const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-edit-3",
  "data-name": "Icon feather-edit-3",
  transform: "translate(-3.5 -3.318)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2419",
  "data-name": "Path 2419",
  d: "M18,30H28.37",
  transform: "translate(-3.13 -5.954)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2420",
  "data-name": "Path 2420",
  d: "M20.055,5.034a2.444,2.444,0,0,1,3.457,3.457l-14.4,14.4L4.5,24.046l1.152-4.609Z",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));
function SvgIconfeatherEdit3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.74,
    height: 21.728,
    viewBox: "0 0 22.74 21.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherEdit3);
export default __webpack_public_path__ + "static/media/Icon feather-edit-3.d2533d95.svg";
export { ForwardRef as ReactComponent };